import Vue from 'vue';
import Router from 'vue-router';
import getCoreUiRoutes from './getCoreUIRoutes';

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');

const KBLogin = () => import('@/views/auth/Login');

// KB VIEWS
const GetStarted = () => import('@/views/GetStarted');
const DownloadBackup = () => import('@/views/DownloadBackup');
const KBAddASite = () => import('@/views/add-a-site/index');
const KBDashboard = () => import('@/views/dashboard/index');
const KBSitesList = () => import('@/views/sites/list');
const KBPlugins = () => import('@/views/plugin/index');
const KBThemes = () => import('@/views/themePage/index');
const KBPlugin = () => import('@/views/plugin/details');
const KBTheme = () => import('@/views/themePage/details');
const KBClients = () => import('@/views/clients/list');
const KBAssets = () => import('@/views/assets/list');
const KBCharges = () => import('@/views/charges/list');
const KBSiteDetails = () => import('@/views/sites/details');
const KBSiteEdit = () => import('@/views/sites/edit');
const KBClientDetails = () => import('@/views/clients/details');
const KBClientEdit = () => import('@/views/clients/edit');
const KBAccountDetails = () => import('@/views/account/details');
const KBOrganisationDetails = () => import('@/views/organisation/details');

const KBUserDetails = () => import('@/views/users/details');
const KBUserEdit = () => import('@/views/users/edit');

const UsernameChange = () => import('@/views/users/usernameChange');
const PasswordReset = () => import('@/views/users/passwordReset');
const ForgotPassword = () => import('@/views/users/ForgotPassword');
const AccountConfirmation = () => import('@/views/users/accountConfirmation');

Vue.use(Router);

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior(to, from, savedPosition) {
    // Always scroll inner scrolling body to top of page.
    const cBody = document.getElementsByClassName('c-body');
    if (cBody && cBody[0]) {
      cBody[0].scrollTo(0, 0);
    }
    // General app scroll top behaviour
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'add-a-site',
          name: 'addASite',
          component: KBAddASite,
          meta: {
            label: 'Add a Site',
            auth: true,
          },
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: KBDashboard,
          meta: {
            label: 'Dashboard',
            auth: true,
          },
        },
        {
          path: 'sites',
          name: 'Sites',
          component: KBSitesList,
          meta: {
            auth: true,
          },
        },
        {
          path: 'plugins',
          name: 'Plugins',
          component: KBPlugins,
          meta: {
            auth: true,
          },
        },
        {
          path: 'plugin/:pluginKey',
          name: 'pluginDetails',
          component: KBPlugin,
          meta: {
            auth: true,
            label: 'Plugin',
          },
        },
        {
          path: 'themes',
          name: 'Themes',
          component: KBThemes,
          meta: {
            auth: true,
          },
        },
        {
          path: 'theme/:themeKey',
          name: 'themeDetails',
          component: KBTheme,
          meta: {
            auth: true,
            label: 'Theme',
          },
        },
        {
          path: 'my-organisation',
          name: 'myOrganisation',
          component: KBOrganisationDetails,
          meta: {
            auth: true,
            label: 'My Organisation',
          },
        },
        {
          path: 'my-account',
          name: 'My Account',
          component: KBAccountDetails,
          meta: {
            auth: true,
          },
        },
        {
          path: 'clients',
          name: 'clients',
          redirect: '/clients/all',
          // component: KBClients,
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            label: 'Clients',
          },
          children: [
            {
              path: 'all',
              name: 'clientsAll',
              component: KBClients,
              meta: {
                auth: true,
                label: 'All Clients',
              },
            },
            {
              name: 'clientDetails',
              path: 'detail/:clientId',
              component: KBClientDetails,
              meta: {
                auth: ['app-admin', 'organisation-admin', 'standard-user'],
                label: 'Client Details',
              },
            },
          ],
        },
        {
          path: 'assets',
          name: 'assets',
          redirect: '/assets/all',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            label: 'Assets',
          },
          children: [
            {
              path: 'all',
              name: 'assetsAll',
              component: KBAssets,
              meta: {
                auth: true,
                label: 'All Assets',
              },
            },
            {
              name: 'assetDetails',
              path: 'detail/:assetId',
              component: KBClientDetails,
              meta: {
                auth: ['app-admin', 'organisation-admin'],
                label: 'Asset Details',
              },
            },
          ],
        },
        {
          path: 'charges',
          name: 'charges',
          redirect: '/charges/all',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            label: 'Charges',
          },
          children: [
            {
              path: 'all',
              name: 'chargesAll',
              component: KBCharges,
              meta: {
                auth: true,
                label: 'All Charges',
              },
            },
            // {
            //   name: 'chargesDetails',
            //   path: 'detail/:chargeId',
            //   component: KBClientDetails,
            //   meta: {
            //     auth: ['app-admin', 'organisation-admin'],
            //     label: 'Asset Details',
            //   },
            // },
          ],
        },
        {
          name: 'detailsUser',
          path: 'user/:userId',
          component: KBUserDetails,
          meta: {
            auth: ['organisation-admin'],
            label: 'User Details',
          },
        },
        {
          name: 'editUser',
          path: 'user/edit/:userId',
          component: KBUserEdit,
          meta: {
            auth: ['organisation-admin'],
            label: 'Edit User',
          },
        },
        {
          name: 'detailsSite',
          path: '/sites/detail/:siteId',
          component: KBSiteDetails,
          meta: {
            label: 'Site Details',
            auth: ['app-admin', 'organisation-admin', 'standard-user'],
          },
          children: [
            {
              name: 'editSite',
              path: '/sites/detail/:siteId/edit',
              component: KBSiteEdit,
              meta: {
                label: 'Edit Site',
                auth: ['app-admin', 'organisation-admin', 'standard-user'],
              },
            },
          ],
        },
        {
          name: 'editClient',
          path: '/clients/edit/:clientId',
          component: KBClientEdit,
          meta: {
            label: 'Edit Client',
            auth: ['app-admin', 'organisation-admin'],
          },
        },
      ].concat(getCoreUiRoutes(false)),
    },
    {
      path: '/get-started',
      name: 'getStarted',
      component: GetStarted,
    },
    {
      path: '/login',
      name: 'login',
      component: KBLogin,
    },
    {
      path: '/account/change-username/:newUsernameRequestKey',
      name: 'emailChange',
      component: UsernameChange,
    },
    {
      path: '/account/password/reset/:passwordResetKey',
      name: 'passwordReset',
      component: PasswordReset,
    },
    {
      path: '/account/password/forgot',
      name: 'passwordForgot',
      component: ForgotPassword,
    },
    {
      path: '/account/confirmation/:confirmationKey',
      name: 'accountConfirmation',
      component: AccountConfirmation,
    },
    {
      path: '/backup/download/:downloadId',
      name: 'downloadBackup',
      component: DownloadBackup,
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: Page404,
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
        },
      ],
    },
  ],
});
